import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import { QUESTION_TYPE } from "lib/constants";
import { questionProps, userShape } from "lib/propTypes";

import LongAnswer from "./Question/LongAnswer";
import SelectOne from "./Question/SelectOne";
import SelectMany from "./Question/SelectMany";
import ShortAnswer from "./Question/ShortAnswer";
import PrefSearchStatus from "./Question/PrefSearchStatus";
import PrefCommuteLength from "./Question/PrefCommuteLength";
import PrefAvailability from "./Question/PrefAvailability";
import PrefWage from "./Question/PrefWage";
import PrefRole from "./Question/PrefRole";
import SelectENPS from "./Question/SelectENPS";

const QUESTION_COMPONENT_MAP = {
    [QUESTION_TYPE.SELECT_ONE]: SelectOne,
    [QUESTION_TYPE.CHOOSE_ONE]: SelectOne,
    [QUESTION_TYPE.RATE_ONE]: SelectOne,
    [QUESTION_TYPE.RATE_SATISFACTION]: SelectOne,
    [QUESTION_TYPE.ENPS]: SelectENPS,
    [QUESTION_TYPE.FOLLOW_UP]: SelectOne,
    [QUESTION_TYPE.CHOOSE_MANY]: SelectMany,
    [QUESTION_TYPE.SHORT_ANSWER]: ShortAnswer,
    [QUESTION_TYPE.LONG_ANSWER]: LongAnswer,
    [QUESTION_TYPE.PREF_SEARCH_STATUS]: PrefSearchStatus,
    [QUESTION_TYPE.PREF_COMMUTE_LENGTH]: PrefCommuteLength,
    [QUESTION_TYPE.PREF_AVAILABILITY]: PrefAvailability,
    [QUESTION_TYPE.PREF_WAGE]: PrefWage,
    [QUESTION_TYPE.PREF_ROLE]: PrefRole,
};

export default function Question({ className, type, ...props }) {
    const QuestionComponent = QUESTION_COMPONENT_MAP[type];

    return (
        <div className={classNames("questions__question", className)}>
            <QuestionComponent type={type} {...props} />
        </div>
    );
}

Question.propTypes = {
    ...questionProps,
    autoSelect: PropTypes.bool.isRequired,
    className: PropTypes.string,
    handleAnswer: PropTypes.func,
    readOnly: PropTypes.bool,
    extraData: PropTypes.shape({ user: userShape, hire_id: PropTypes.number }),
    isLastQuestion: PropTypes.bool,
};

Question.defaultProps = {
    className: null,
    handleAnswer: () => {},
    readOnly: false,
    extraData: {},
    isLastQuestion: false,
};
